function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "resources_svg__a",
  d: "M20 40a20 20 0 1120-20 20 20 0 01-20 20zm0-38.25A18.25 18.25 0 1038.25 20 18.27 18.27 0 0020 1.75z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "resources_svg__a",
  d: "M27.88 14.09S23.52 11.5 20 9.38s-8.71-2.44-8.71-2.44l-.16.78a30.53 30.53 0 013.25.87 21.08 21.08 0 014.35 2.61l1 1.88-9.45 15.45a1.57 1.57 0 00.53 2.16 1.47 1.47 0 00.82.23 1.59 1.59 0 001.37-.75l9.28-15.08 3.55 2.31zM25.53 20.55l-1.22 1.08.23 2.69 1.22.77 2.12-2.49zM27.42 25.49l3.6-.4 1 1.67.08 1.76-1.38 1.76-4.13-.16zM22.84 26.39l-3.11.95-.93 3 3.65 1.6 1.86-1.68z"
});

function SvgResources(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "assets/images/resources.41d842ca.svg";
export { SvgResources as ReactComponent };